import { ref, readonly } from 'vue'
import { fetchWhatsappAccount } from '../whatsappService'
import type { WhatsappAccount } from '../types'

// Module-level singleton: shared across all views while the page is alive.
// Resets on full page reload (which happens on studio switch).
const account  = ref<WhatsappAccount | null | undefined>(undefined) // undefined = not loaded yet
const loading  = ref(false)
const loaded   = ref(false)

export function useWhatsappAccount() {
  const load = async (force = false) => {
    if (loaded.value && !force) return
    loading.value = true
    try {
      account.value = await fetchWhatsappAccount()
    } finally {
      loading.value = false
      loaded.value  = true
    }
  }

  const setAccount = (value: WhatsappAccount | null) => {
    account.value = value
  }

  const isActive = () => account.value?.is_active === true

  return {
    account:  readonly(account),
    loading:  readonly(loading),
    loaded:   readonly(loaded),
    isActive,
    load,
    setAccount,
  }
}
